import { useCallback } from 'react';
import { filterOperatorOptions } from '@fabric-ui/components';

/**
 * Returns a stable `getErrors` validator for a given field type, delegating to the
 * type-specific `getErrors` implementation registered in `filterOperatorOptions`.
 */
export const useFilterValidation = (type: string) =>
  useCallback(
    (val: unknown, operator: string | undefined): string[] | undefined =>
      !operator ? ['Select Operator'] : filterOperatorOptions[type].find(({ value }) => value === operator)?.getErrors?.(val),
    [type]
  );
